import actionTypes from './actionTypes';

export const changeLocale = () => ({
    type: actionTypes.CHANGE_LOCALE,
});
